import { useEffect } from 'react'

const useChangePassword = () => {
    useEffect(() => {
        dataLayer.push({
            event: 'forgot_password',
            step: 'form_view_new_password',
            _clear: true,
        })
    }, [])
}

export default useChangePassword
